// 从 npm 获取 sdk
import  AnalysysAgent from 'ans-javascript-sdk/SDK/AnalysysAgent_JS_SDK.es6.min.js'

AnalysysAgent.init({
  appkey: process.env.VUE_APP_ARK_APPKEY,//APPKEY
  uploadURL: 'https://ark-collector.aikucun.com',//上传数据的地址
  // debugMode: 1,
  pageProperty: {
    pageType: 'PC'
  }
})

export default {
  track(eventName, eventInfo) {
    return AnalysysAgent.track(eventName, eventInfo);
  }
};